/**
 * SEPA-Zeitraum-Export darf nur nach erfolgreicher Vorschau schreiben.
 *
 * Nach #880 (keine 2000er-Grenze) und #882 (leerer Dialog ohne previewErrors)
 * wäre `paymentCount === undefined` sonst klickbar: der Server lastschriftet
 * ohne Zeitraum alle offenen Raten des Mandanten und markiert sie bezahlt.
 */
export const hasSepaPreviewPaymentCount = (paymentCount?: number): boolean => typeof paymentCount === "number" && paymentCount > 0;
